<template>
  <el-dialog
    title="排重"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    width="700px"
    @close="close"
  >
    <el-form
      :model="uniqueForm"
      :label-width="'85px'"
      status-icon
      :rules="rules"
      :disabled="isReadOnly"
      ref="ruleForm"
    >
      <el-form-item label="节点名称" prop="name">
        <el-input
          v-model="uniqueForm.name"
          show-word-limit
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="排重优先级">
        <el-table
          :data="uniqueForm.excludeRepeatNode.removeDuplicateNodeList"
          class="uploadTable"
          :empty-text="'请先连入节点'"
        >
          <el-table-column
            prop="sort"
            align="center"
            width="70"
            label="优先级"
          ></el-table-column>
          <el-table-column
            prop="inputNodeName"
            align="center"
            width="100"
            label="输入节点名称"
          ></el-table-column>
          <el-table-column
            prop="outNodeName"
            align="center"
            label="输出节点名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.outNodeName"
                placeholder="请输入输出节点名称"
                style="100%"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="inputNodeId"
            align="center"
            width="160"
            label="调整优先级"
          >
            <template slot-scope="scope" >
              <el-button
                @click="handelSort(scope.$index, 'up')"
                type="text"
                class="flag"
                icon="el-icon-arrow-up"
              ></el-button>
              <el-button
                @click="handelSort(scope.$index, 'down')"
                type="text"
                class="flag"
                icon="el-icon-arrow-down"
              ></el-button>
              <el-button
                @click="handelSort(scope.$index, 'top')"
                type="text"
                class="flag"
                icon="el-icon-upload2"
              ></el-button>
              <el-button
                @click="handelSort(scope.$index, 'bottom')"
                type="text"
                class="flag"
                icon="el-icon-download"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" v-loading="loading" :disabled="isReadOnly" @click="uniqueSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "uniqueDialog",
  data() {
    return {
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      uniqueForm: {
        name: "",
        excludeRepeatNode: {
          removeDuplicateNodeList: [],
        },
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
  },
  components: {},
  created () {
    mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        this.uniqueForm.name = res.data.name
        if (res.data.removeDuplicateNodeList && res.data.removeDuplicateNodeList.length > 1) {
          res.data.removeDuplicateNodeList.map((i,index)=>i.sort = index+1)
          this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList = res.data.removeDuplicateNodeList
        }
      }
    })
  },
  methods: {
    //确定
    uniqueSubmit () {
       if (this.loading) {
        return;
      }
      
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify()
          let dataremove = {}
          dataremove.name=data.name;
          dataremove.nodeId=data.nodeId;
          dataremove.removeDuplicateNodeRules=data.excludeRepeatNode.removeDuplicateNodeList;
          if (dataremove) {
            this.loading = true;
            mnode.updateDetailremoveDup(dataremove).then(res => {
              this.loading = false;
              if (res.code === 1) {
                this.viewVisible = false
                this.$emit('change', {})
                this.$emit('change-name', dataremove)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    //关闭
    close() {
      this.viewVisible = false;
    },
    handelSort (index, type) {
      let list = JSON.parse(JSON.stringify(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList))
      let row = list[index]
      let trow
      let l
      switch (type) {
        case 'up':
          if (index === 0) {
            return
          }
          l = index - 1
          break
        case 'down':
          if (index === this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList - 1) {
            return
          }
          l = index + 1
          break
        case 'top':
          if (index === 0) {
            return
          }
          l = 0
          break
        case 'bottom':
          l = this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList.length - 1
          if (index === l) {
            return
          }
          break
      }
      row.sort = l + 1
      trow = list[l]
      // trow.index = index + 1
      trow.sort = index + 1
      this.$set(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList, l, row)
      this.$set(this.uniqueForm.excludeRepeatNode.removeDuplicateNodeList, index, trow)
    },
    getDataify () {
      let data = JSON.parse(JSON.stringify(this.uniqueForm))
      if (data.excludeRepeatNode.removeDuplicateNodeList.some(i => i.outNodeName.length === 0 || i.outNodeName.length > 20)) {
        this.$message.error('输出节点名称必填且小于20个字！')
        return false
      }
      data.nodeId = this.$props.nodeId
      return data
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table .el-table__header-wrapper th .cell{
   color: #333;
   font-weight: 600;
}
/deep/ .flag .el-button{
  width: 0px;
}
</style>
